//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  cloneDeep,
  dig,
} from '@/utils/lodash'
import { Popup } from 'vant'
import { isEmptyAll } from '../../utils/validator'
import { filterByLabelFormat } from '../../utils/translate'

export default {
  components: { Popup },

  props: {
    value: {
      type: [
        Array,
        Object,
      ],
    },

    dataHook: { type: Function },

    dataPath: {
      type: String,
      default: 'data',
    },

    list: {
      type: Array,
      default: () => ([]),
    },

    apiMethod: { type: Function },

    params: {
      type: Object,
      default: () => ({}),
    },

    labelFormat: {
      type: String,
      default: '{value}',
    },

    readonly: {
      type: Boolean,
      default: false,
    },

    valueName: {
      type: String,
      default: 'key',
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    clearable: {
      type: Boolean,
      default: true,
    },
  },

  data () {
    return {
      popupChangeSelected: [],
      popupVisible: false,
      currentNameIsEmpty: false,
      options: [],
    }
  },

  computed: {
    rightIcon () {
      return (this.readonly || this.disabled || !this.clearable) ? '' : (this.currentNameIsEmpty ? 'arrow' : 'cross')
    },

    showName: {
      get () {
        return this.options.filter((el) => this.value?.indexOf(el.value) >= 0).map((el) => el.text)
          .join(',')
      },
      set (val) {

      },
    },

  },

  watch: {
    showName (val) {
      this.currentNameIsEmpty = isEmptyAll(val)
    },

    value: {
      async handler (val, old) {
        if (!isEmptyAll(val) && isEmptyAll(old) && !this.options?.length) {
          await this.doQuery()
        }

        this.popupChangeSelected = cloneDeep(this.value) || []

        this.$emit('on-change', val, this.options)
      },
      deep: true,
      immediate: true,
    },

    list: {
      deep: true,
      immediate: true,
      handler (v) {
        if (v?.length) {
          this.options = this.filterData(v)
        }
      },
    },

  },

  methods: {
    rightIconClick () {
      if (this.currentNameIsEmpty && this.rightIcon === 'arrow') {
        this.showPopup()
      } else {
        this.doClear()
      }
    },

    onConfirm () {
      this.$emit('input', cloneDeep(this.popupChangeSelected))
      this.popupVisible = false
    },

    doClear () {
      this.$emit('input', this.value === undefined ? undefined : [])
    },

    handlerClearPopup () {
      this.popupChangeSelected = []
    },

    async doQuery () {
      if (this.apiMethod) {
        const result = await this.apiMethod({ ...this.params })

        let data = dig(result, this.dataPath) || []

        if (this.dataHook) {
          data = this.dataHook(data || [])
        }

        this.options = this.filterData(data || [])
      }
    },

    filterData (data) {
      return data.map((el) => {
        return {
          text: el[this.valueName],
          value: filterByLabelFormat(el, this.labelFormat),
        }
      })
    },

    handlerCancel () {
      this.popupVisible = false
    },

    async showPopup () {
      if (isEmptyAll(this.value) && !this.options?.length) {
        await this.doQuery()
      }

      this.popupVisible = true
    },
  },

}
